import { useState } from "react";
import { ConfirmModalDescriptor } from "./GlobalConfirmModal/types";
import { TextPromptModalDescriptor } from "./GlobalTextPromptModal";

export type ModalDescriptor =
  | ConfirmModalDescriptor
  | TextPromptModalDescriptor;

export type StackControls = {
  pushDescriptorToStack: (descriptor: ModalDescriptor) => void;
  removeDescriptorFromStack: (descriptor: ModalDescriptor) => void;
};

const useModalStack = () => {
  const [descriptorStack, setDescriptorStack] = useState<ModalDescriptor[]>([]);

  const pushDescriptorToStack = (descriptor: ModalDescriptor) => {
    setDescriptorStack((prev) => [...prev, descriptor]);
  };

  const removeDescriptorFromStack = (descriptor: ModalDescriptor) => {
    setDescriptorStack((prev) => prev.filter((d) => d !== descriptor));
  };

  const controls = { pushDescriptorToStack, removeDescriptorFromStack };

  const currentDescriptor: ModalDescriptor | undefined = descriptorStack[0];

  return { currentDescriptor, controls };
};

export default useModalStack;
